export class RequestStoppingReasonAliasDto {
    requestStoppingReasonAliasId: number;
    requestStoppingReasonId: number;
    text: string;
    contragentId: number;
    additionalCommentRequired: boolean;
}